import { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SourceStoryInfo } from '../../../services';
import { getCssVar, IconLabel, Modal } from '../../../shared';

import classes from './SourceStoriesModal.module.scss';

interface SourceStoriesModalProps {
  isOpen: boolean;
  sources: SourceStoryInfo[];
  onSourceClick: (source: SourceStoryInfo) => void;
  onClose: () => void;
}

export const SourceStoriesModal: FunctionComponent<SourceStoriesModalProps> = ({
  isOpen,
  sources,
  onSourceClick,
  onClose,
}) => {
  const { t } = useTranslation();

  const title = t('storyFeed.source-mixes-title');

  const body = useMemo(
    () => (
      <>
        <div className={classes['source-stories__title']}>{title}</div>

        <div className={classes['source-stories__subtitle']}>
          {t('storyFeed.source-mixes-subtitle')}
        </div>

        <div className={classes['source-stories__list']}>
          {sources.map((source) => {
            const {
              channel: { name },
              story: { id, title },
            } = source;

            return (
              <div
                key={id}
                className={classes['source-stories__row']}
                onClick={() => onSourceClick(source)}
              >
                <div className={classes['source-stories__row-text']}>
                  <div className={classes['source-stories__row-channel']}>{name}</div>
                  <div className={classes['source-stories__row-mix']}>{title}</div>
                </div>

                <IconLabel
                  iconId={'arrow-rounded-right-up-box'}
                  iconSize={16}
                  color={getCssVar('--base-link-text-color')}
                  hoverColor={getCssVar('--base-link-text-hover-color')}
                  className={classes['source-stories__row-open']}
                />
              </div>
            );
          })}
        </div>
      </>
    ),
    [onSourceClick, sources, t, title]
  );

  return <Modal isOpen={isOpen} body={body} onClose={onClose} ariaLabel={title} alignTop />;
};
